module.exports = __webpack_public_path__ + "img/error400.4d940c04.jpg";